const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3EBFEE"
    },
    width: 750,
    height: 500
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M640.547,441.011c32.207-34.49,61.084-94.994,61.084-164.372 c0-53.662-15.688-99.348-61.84-99.348c-23.731,0-47.822,12.154-71.939,12.154c-60.147,0-77.344-86.436-166.896-86.436 c-124.784,0-99.282,127.835-175.581,127.835c-25.421,0-63.447-26.911-88.83-26.911c-61.191,0-88.176,63.584-88.176,132.399 c0,39.777,9.503,79.497,26.894,104.68H640.547z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M197.23,125.182c-16.484,6.025-29.593,20.323-29.593,42.707 c0,23.729,22.232,43.401,47.304,43.401c23.211,0,47.791-17.84,47.792-44.636C262.734,128.501,225.143,114.979,197.23,125.182z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M558.841,101.572c-13.682,5.001-24.564,16.869-24.564,35.449 c0,19.696,18.454,36.025,39.265,36.025c19.267,0,39.669-14.808,39.67-37.051C613.213,104.327,582.01,93.103,558.841,101.572z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#958DEB"
    },
    d: "M685.093,448.691H66.082c-2.542,0-4.603-2.061-4.603-4.603l0,0c0-2.542,2.061-4.603,4.603-4.603 h619.011c2.542,0,4.603,2.061,4.603,4.603l0,0C689.696,446.63,687.635,448.691,685.093,448.691z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M89.856,115.606c-0.276,0-0.5-0.224-0.5-0.5v-11.44c0-0.276,0.224-0.5,0.5-0.5 s0.5,0.224,0.5,0.5v11.44C90.356,115.383,90.133,115.606,89.856,115.606z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M95.577,109.887h-11.44c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h11.44 c0.276,0,0.5,0.224,0.5,0.5S95.853,109.887,95.577,109.887z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M656.904,160.558c-0.276,0-0.5-0.224-0.5-0.5v-11.44c0-0.276,0.224-0.5,0.5-0.5 s0.5,0.224,0.5,0.5v11.44C657.404,160.334,657.181,160.558,656.904,160.558z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M662.624,154.837h-11.44c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h11.44 c0.276,0,0.5,0.224,0.5,0.5S662.9,154.837,662.624,154.837z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M253.536,115.151c-0.276,0-0.5-0.224-0.5-0.5v-8.322c0-0.276,0.224-0.5,0.5-0.5 s0.5,0.224,0.5,0.5v8.322C254.036,114.927,253.813,115.151,253.536,115.151z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M257.697,110.99h-8.322c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h8.322 c0.276,0,0.5,0.224,0.5,0.5S257.974,110.99,257.697,110.99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M573.744,73.292c-0.276,0-0.5-0.224-0.5-0.5V64.47c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5 v8.322C574.244,73.068,574.021,73.292,573.744,73.292z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M577.905,69.131h-8.322c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h8.322 c0.276,0,0.5,0.224,0.5,0.5S578.182,69.131,577.905,69.131z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M405.542,54.401c-0.276,0-0.5-0.224-0.5-0.5v-8.322c0-0.276,0.224-0.5,0.5-0.5 s0.5,0.224,0.5,0.5v8.322C406.042,54.177,405.818,54.401,405.542,54.401z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M409.703,50.24h-8.322c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h8.322 c0.276,0,0.5,0.224,0.5,0.5S409.979,50.24,409.703,50.24z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M265.051,44.096c-0.276,0-0.5-0.224-0.5-0.5V31.915c0-0.276,0.224-0.5,0.5-0.5 s0.5,0.224,0.5,0.5v11.681C265.551,43.872,265.327,44.096,265.051,44.096z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M270.891,38.255h-11.68c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h11.68 c0.276,0,0.5,0.224,0.5,0.5S271.167,38.255,270.891,38.255z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M681.169,86.278c-0.276,0-0.5-0.224-0.5-0.5v-10.11c0-0.276,0.224-0.5,0.5-0.5 s0.5,0.224,0.5,0.5v10.11C681.669,86.055,681.445,86.278,681.169,86.278z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M686.224,81.223h-10.11c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h10.11 c0.276,0,0.5,0.224,0.5,0.5S686.5,81.223,686.224,81.223z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M161.069,58.668c-2.599,0-4.714-2.115-4.714-4.714c0-2.6,2.115-4.714,4.714-4.714 c2.6,0,4.714,2.115,4.714,4.714C165.783,56.553,163.668,58.668,161.069,58.668z M161.069,50.24 c-2.048,0-3.714,1.666-3.714,3.714c0,2.048,1.666,3.714,3.714,3.714c2.048,0,3.714-1.666,3.714-3.714 C164.783,51.906,163.117,50.24,161.069,50.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M637.878,103.175c-2.599,0-4.714-2.115-4.714-4.714c0-2.6,2.115-4.714,4.714-4.714 c2.6,0,4.714,2.115,4.714,4.714C642.592,101.061,640.478,103.175,637.878,103.175z M637.878,94.747 c-2.048,0-3.714,1.666-3.714,3.714c0,2.048,1.666,3.714,3.714,3.714c2.048,0,3.714-1.666,3.714-3.714 C641.592,96.413,639.926,94.747,637.878,94.747z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M470.631,51.614c-3.408,0-6.181-2.773-6.181-6.181s2.772-6.181,6.181-6.181 s6.181,2.772,6.181,6.181S474.04,51.614,470.631,51.614z M470.631,40.252c-2.856,0-5.181,2.324-5.181,5.181 c0,2.857,2.324,5.181,5.181,5.181c2.857,0,5.181-2.324,5.181-5.181C475.813,42.576,473.488,40.252,470.631,40.252z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M64.102,71.711c-3.208,0-5.817-2.61-5.817-5.817s2.609-5.817,5.817-5.817 s5.817,2.609,5.817,5.817S67.31,71.711,64.102,71.711z M64.102,61.077c-2.656,0-4.817,2.161-4.817,4.817 s2.161,4.817,4.817,4.817s4.817-2.161,4.817-4.817S66.758,61.077,64.102,61.077z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M288.091,142.118c-2.084,0-3.78-1.696-3.78-3.78s1.696-3.78,3.78-3.78s3.78,1.696,3.78,3.78 S290.176,142.118,288.091,142.118z M288.091,135.558c-1.533,0-2.78,1.247-2.78,2.78s1.247,2.78,2.78,2.78s2.78-1.247,2.78-2.78 S289.625,135.558,288.091,135.558z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M667.015,250.752c-0.276,0-0.5-0.224-0.5-0.5v-10.11c0-0.276,0.224-0.5,0.5-0.5 s0.5,0.224,0.5,0.5v10.11C667.515,250.529,667.291,250.752,667.015,250.752z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M672.07,245.697h-10.11c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h10.11 c0.276,0,0.5,0.224,0.5,0.5S672.346,245.697,672.07,245.697z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M589.7,227.213c-0.276,0-0.5-0.224-0.5-0.5v-10.11c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5 v10.11C590.2,226.99,589.976,227.213,589.7,227.213z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M594.755,222.158h-10.11c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h10.11 c0.276,0,0.5,0.224,0.5,0.5S595.031,222.158,594.755,222.158z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M143.513,319.288c-0.276,0-0.5-0.224-0.5-0.5v-10.11c0-0.276,0.224-0.5,0.5-0.5 s0.5,0.224,0.5,0.5v10.11C144.013,319.064,143.789,319.288,143.513,319.288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M148.568,314.232h-10.11c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h10.11 c0.276,0,0.5,0.224,0.5,0.5S148.844,314.232,148.568,314.232z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M347.389,161.681c-0.276,0-0.5-0.224-0.5-0.5v-12.564c0-0.276,0.224-0.5,0.5-0.5 s0.5,0.224,0.5,0.5v12.564C347.889,161.458,347.665,161.681,347.389,161.681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M353.67,155.399h-12.563c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h12.563 c0.276,0,0.5,0.224,0.5,0.5S353.947,155.399,353.67,155.399z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M419.282,212.005c-0.276,0-0.5-0.224-0.5-0.5v-16.303c0-0.276,0.224-0.5,0.5-0.5 s0.5,0.224,0.5,0.5v16.303C419.782,211.782,419.559,212.005,419.282,212.005z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M427.434,203.854H411.13c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h16.303 c0.276,0,0.5,0.224,0.5,0.5S427.71,203.854,427.434,203.854z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M191.125,341.354c-2.599,0-4.714-2.114-4.714-4.714s2.115-4.715,4.714-4.715 c2.6,0,4.714,2.115,4.714,4.715S193.724,341.354,191.125,341.354z M191.125,332.926c-2.048,0-3.714,1.666-3.714,3.715 c0,2.048,1.666,3.714,3.714,3.714c2.048,0,3.714-1.666,3.714-3.714C194.839,334.592,193.173,332.926,191.125,332.926z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M309.596,209.663c-3.278,0-5.945-2.667-5.945-5.945s2.667-5.945,5.945-5.945 c3.278,0,5.945,2.667,5.945,5.945S312.874,209.663,309.596,209.663z M309.596,198.773c-2.727,0-4.945,2.218-4.945,4.945 s2.218,4.945,4.945,4.945c2.727,0,4.945-2.218,4.945-4.945S312.323,198.773,309.596,198.773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M463.539,164.172c-3.797,0-6.887-3.089-6.887-6.887c0-3.798,3.089-6.887,6.887-6.887 c3.798,0,6.887,3.089,6.887,6.887C470.426,161.083,467.336,164.172,463.539,164.172z M463.539,151.398 c-3.246,0-5.887,2.641-5.887,5.887s2.641,5.887,5.887,5.887s5.887-2.641,5.887-5.887S466.785,151.398,463.539,151.398z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M629.319,217.366c-3.133,0-5.683-2.549-5.683-5.683s2.549-5.682,5.683-5.682 s5.682,2.549,5.682,5.682S632.452,217.366,629.319,217.366z M629.319,207.001c-2.582,0-4.683,2.101-4.683,4.682 c0,2.582,2.101,4.683,4.683,4.683c2.582,0,4.682-2.101,4.682-4.683C634.001,209.102,631.9,207.001,629.319,207.001z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M188.146,283.422c-3.107,0-5.636-2.528-5.636-5.636s2.528-5.636,5.636-5.636 s5.636,2.528,5.636,5.636S191.254,283.422,188.146,283.422z M188.146,273.15c-2.556,0-4.636,2.079-4.636,4.636 s2.08,4.636,4.636,4.636s4.636-2.079,4.636-4.636S190.703,273.15,188.146,273.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EBFEE"
    },
    d: "M68.548,311.143c-2.727,0-4.946-2.219-4.946-4.946c0-2.727,2.219-4.945,4.946-4.945 s4.946,2.219,4.946,4.945C73.494,308.924,71.275,311.143,68.548,311.143z M68.548,302.251c-2.176,0-3.946,1.77-3.946,3.945 s1.77,3.946,3.946,3.946s3.946-1.771,3.946-3.946S70.724,302.251,68.548,302.251z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M467.851,71.257c0-2.962-2.401-5.363-5.363-5.363H289.915c-2.962,0-5.363,2.401-5.363,5.363 v1.333h183.299V71.257z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M284.552,72.59v35.17c0,2.1,0.456,4.175,1.336,6.082h180.627c0.88-1.907,1.336-3.982,1.336-6.082 V72.59H284.552z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M288.26,118.983c1.275,2.763,4.04,4.532,7.083,4.532h161.716c3.043,0,5.808-1.769,7.083-4.532 l2.373-5.141H285.887L288.26,118.983z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6FE"
    },
    points: "454.392,118.678 298.01,118.678 295.414,113.842 456.988,113.842  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M440.107,108.674H308.049c-1.941,0-3.514-1.573-3.514-3.514v-4.303 c0-1.941,1.573-3.514,3.514-3.514h132.057c1.941,0,3.514,1.573,3.514,3.514v4.303 C443.621,107.101,442.047,108.674,440.107,108.674z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEDCFA"
    },
    d: "M392.873,106.729h-33.344c-0.878,0-1.589-0.712-1.589-1.589v-4.261 c0-0.878,0.712-1.589,1.589-1.589h33.344c0.878,0,1.589,0.712,1.589,1.589v4.261 C394.462,106.017,393.751,106.729,392.873,106.729z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M455.926,77.575H296.477c-0.584,0-1.062-0.478-1.062-1.062v0c0-0.584,0.478-1.062,1.062-1.062 h159.449c0.584,0,1.062,0.478,1.062,1.062v0C456.988,77.097,456.51,77.575,455.926,77.575z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M455.926,82.266H296.477c-0.584,0-1.062-0.478-1.062-1.062l0,0c0-0.584,0.478-1.062,1.062-1.062 h159.449c0.584,0,1.062,0.478,1.062,1.062l0,0C456.988,81.788,456.51,82.266,455.926,82.266z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M455.926,86.958H296.477c-0.584,0-1.062-0.478-1.062-1.062l0,0c0-0.584,0.478-1.062,1.062-1.062 h159.449c0.584,0,1.062,0.478,1.062,1.062l0,0C456.988,86.48,456.51,86.958,455.926,86.958z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A3EB73"
    },
    cx: 436.492,
    cy: 69.242,
    r: 1.633
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A3EB73"
    },
    cx: 445.756,
    cy: 69.242,
    r: 1.633
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A3EB73"
    },
    cx: 455.02,
    cy: 69.242,
    r: 1.633
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M142.181,161.631h-4v-58.892c0-6.556,5.333-11.89,11.89-11.89h134.481v4H150.071 c-4.351,0-7.89,3.54-7.89,7.89V161.631z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M199.159,259.791H81.506c-7.156,0-12.958-5.801-12.958-12.958V170.93 c0-7.156,5.801-12.958,12.958-12.958h117.654c7.156,0,12.958,5.801,12.958,12.958v75.904 C212.117,253.99,206.316,259.791,199.159,259.791z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M198.786,254.418H81.878c-3.987,0-7.231-3.244-7.231-7.232v-76.608 c0-3.988,3.244-7.232,7.231-7.232h116.908c3.987,0,7.231,3.244,7.231,7.232v76.607 C206.018,251.174,202.774,254.418,198.786,254.418z M81.878,164.346c-3.436,0-6.231,2.795-6.231,6.232v76.608 c0,3.437,2.795,6.232,6.231,6.232h116.908c3.437,0,6.232-2.796,6.232-6.232v-76.607c0-3.437-2.795-6.232-6.231-6.232H81.878z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#857DE2"
    },
    cx: 115.033,
    cy: 209.04,
    r: 31.413
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M114.606,209.16c-0.553,0.286-6.353-12.83-3.862-19.557c2.491-6.727,12.083-7.1,16.069-1.993 C130.8,192.717,128.807,201.81,114.606,209.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M114.606,209.16c0.524,0.336-7.935,11.917-15.006,13.122c-7.071,1.206-12.19-6.914-9.76-12.92 C92.27,203.357,101.142,200.536,114.606,209.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M114.606,209.16c0.029-0.622,14.288,0.913,18.867,6.434c4.58,5.521,0.108,14.014-6.308,14.913 C120.749,231.405,113.871,225.132,114.606,209.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4B5DB3"
    },
    cx: 114.549,
    cy: 208.607,
    r: 5.657
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.442,
    y: 182.075,
    style: {
      fill: "#FFFFFF"
    },
    width: 69.443,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.442,
    y: 189.591,
    style: {
      fill: "#FFFFFF"
    },
    width: 69.443,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.442,
    y: 197.107,
    style: {
      fill: "#FFFFFF"
    },
    width: 69.443,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.442,
    y: 204.624,
    style: {
      fill: "#FFFFFF"
    },
    width: 69.443,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.442,
    y: 212.14,
    style: {
      fill: "#FFFFFF"
    },
    width: 69.443,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.442,
    y: 219.656,
    style: {
      fill: "#FFFFFF"
    },
    width: 69.443,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.442,
    y: 227.172,
    style: {
      fill: "#FFFFFF"
    },
    width: 69.443,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.442,
    y: 234.688,
    style: {
      fill: "#FFFFFF"
    },
    width: 69.443,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 141.97,
    y: 174.16,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 69.443
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.454,
    y: 174.16,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 69.443
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.938,
    y: 174.16,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 69.443
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 119.421,
    y: 174.16,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 69.443
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.905,
    y: 174.16,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 69.443
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.389,
    y: 174.16,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 69.443
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.873,
    y: 174.16,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 69.443
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.356,
    y: 174.16,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 69.443
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M192.639,184.88h-35.813c-0.858,0-1.56-0.702-1.56-1.56l0,0c0-0.858,0.702-1.56,1.56-1.56 h35.813c0.858,0,1.56,0.702,1.56,1.56l0,0C194.199,184.177,193.497,184.88,192.639,184.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M192.639,194.854h-35.813c-0.858,0-1.56-0.702-1.56-1.56v0c0-0.858,0.702-1.56,1.56-1.56h35.813 c0.858,0,1.56,0.702,1.56,1.56v0C194.199,194.152,193.497,194.854,192.639,194.854z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M192.639,204.829h-35.813c-0.858,0-1.56-0.702-1.56-1.56l0,0c0-0.858,0.702-1.56,1.56-1.56 h35.813c0.858,0,1.56,0.702,1.56,1.56l0,0C194.199,204.127,193.497,204.829,192.639,204.829z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M192.639,214.804h-35.813c-0.858,0-1.56-0.702-1.56-1.56l0,0c0-0.858,0.702-1.56,1.56-1.56 h35.813c0.858,0,1.56,0.702,1.56,1.56l0,0C194.199,214.102,193.497,214.804,192.639,214.804z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M192.639,224.778h-35.813c-0.858,0-1.56-0.702-1.56-1.56v0c0-0.858,0.702-1.56,1.56-1.56h35.813 c0.858,0,1.56,0.702,1.56,1.56v0C194.199,224.076,193.497,224.778,192.639,224.778z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M192.639,234.753h-35.813c-0.858,0-1.56-0.702-1.56-1.56l0,0c0-0.858,0.702-1.56,1.56-1.56 h35.813c0.858,0,1.56,0.702,1.56,1.56l0,0C194.199,234.051,193.497,234.753,192.639,234.753z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M101.49,264.244h-6.711c-2.351,0-4.257-1.906-4.257-4.257v-0.196h15.225v0.196 C105.747,262.339,103.841,264.244,101.49,264.244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M183.89,264.244h-6.711c-2.351,0-4.257-1.906-4.257-4.257v-0.196h15.225v0.196 C188.147,262.339,186.241,264.244,183.89,264.244z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M214.186,246.187l-2.069,0.47v-21.878l2.069,0.47c2.271,0.516,3.86,2.337,3.86,4.423v12.093 C218.045,243.85,216.456,245.671,214.186,246.187z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M214.186,188.982l-2.069,0.254v-11.834l2.069,0.254c2.271,0.279,3.86,1.264,3.86,2.392v6.541 C218.045,187.718,216.456,188.703,214.186,188.982z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 156.713,
    y: 242.105,
    transform: "matrix(0.9913 -0.1313 0.1313 0.9913 -31.7437 22.9949)",
    style: {
      fill: "#1B1447"
    },
    width: 3.643,
    height: 20.312
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M158.118,236.718l0.467,3.529c0.118,0.887-0.512,1.709-1.4,1.827 c-0.887,0.118-1.709-0.512-1.827-1.4l-0.467-3.529c-1.344,0.812-2.154,2.366-1.935,4.022c0.295,2.23,2.343,3.799,4.573,3.504 s3.799-2.343,3.504-4.573C160.814,238.441,159.628,237.152,158.118,236.718z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M159.119,269.068l-0.467-3.529c-0.117-0.887,0.512-1.709,1.4-1.827s1.709,0.512,1.827,1.4 l0.467,3.529c1.344-0.812,2.154-2.366,1.935-4.022c-0.295-2.23-2.343-3.799-4.573-3.504s-3.799,2.343-3.504,4.573 C156.423,267.344,157.609,268.634,159.119,269.068z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F91"
    },
    d: "M163.3,248.946c-0.542-0.883-1.324-1.782-2.36-1.817c-0.93-0.032-1.762,0.656-2.693,0.668 c-0.739,0.01-1.435-0.409-2.173-0.389c-2.15,0.058-5.489,5.681-7.64,5.686l2.911,4.398c2.536,0.829,5.235,1.503,7.852,0.986 s5.108-2.542,5.355-5.199C164.694,251.755,164.1,250.25,163.3,248.946z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M129.592,255.418c-2.075-11.963-2.438-23.033-13.119-31.918l-8.807,19.714 c1.496,8.565,5.647,16.772,11.02,23.68C122.608,263.531,126.157,259.428,129.592,255.418z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F91"
    },
    d: "M152.448,251.316c-5.923,2.388-16.454,3.698-22.775,4.57c-0.028-0.156-0.054-0.312-0.081-0.468 c-3.435,4.009-6.984,8.113-10.905,11.475c0.261,0.335,0.522,0.671,0.788,1c0.76,0.938,1.894,1.491,3.1,1.549 c10.482,0.496,24.302-6.564,32.815-11.651C154.915,254.271,154.698,253.593,152.448,251.316z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M76.248,429.549c-0.182,0.242-3.029,3.272-3.029,9.936h22.78c0,0-0.545-6.24-8.967-6.967 S76.248,429.549,76.248,429.549z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M115.687,429.549c-0.138,0.242-2.438,3.272-1.234,9.936h22.78c0,0-1.672-6.24-10.225-6.967 S115.687,429.549,115.687,429.549z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M126.576,306.197H80.44v17.317c0.311,5.289-1.111,67.906-5.794,108.031 c4.133,3.431,9.07,2.192,14.888,1.621c7.856-25.015,12.727-67.175,14.428-100.783c3.505,22.917,8.722,71.6,10.484,99.162 c4.752,3.431,9.466,2.192,15.181,1.621C133.599,403.387,126.576,306.197,126.576,306.197z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M126.821,309.682c-6.473,4.076-36.439,5.102-46.38,0.69c-0.635-16.386-0.527-32.545-0.145-45.608 c0.418-14.234,1.162-24.792,1.616-27.97c1.28-8.915,6.037-12.564,10.431-14.044c1.189-0.39,2.351-0.635,3.413-0.772 c0.717-0.1,1.398-0.145,1.997-0.172c1.807-0.073,3.005,0,3.005,0h6.709c0,0,1.507-0.1,3.677,0.036 c0.853,0.045,1.707,0.2,2.551,0.445s1.67,0.599,2.469,1.044c2.914,1.598,5.429,4.457,6.781,8.388 c0.999,2.932,1.816,12.128,2.442,23.621C126.331,272.752,126.821,295.447,126.821,309.682z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M108.045,245.512c-1.826,4.851-4.414,9.782-8.079,13.373c3.955,2.608,9.314,4.81,15.21,6.54 c2.086-3.408,3.685-7.153,5.027-10.848C116.6,252.256,112.571,249.293,108.045,245.512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M154.924,252.055c-0.368-0.845-0.947-1.735-1.855-1.895c-0.816-0.144-1.635,0.359-2.457,0.255 c-0.652-0.083-1.214-0.538-1.867-0.612c-4.957-0.562-8.247,9.427-32.458,3.719c-0.03,3.931-0.286,7.995-1.112,11.905 c10.608-0.588,22.262-3.046,30.658-6.228c1.388,0.507,2.825,0.832,4.292,0.751c2.372-0.132,4.819-1.607,5.366-3.919 C155.806,254.704,155.469,253.303,154.924,252.055z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M91.648,225.316c-6.997-4.038-17.392,11.41-8.598,19.704c6.065,6.413,7.24,7.521,17.17,15.654 c4.116-4.033,7.024-9.571,9.075-15.021C104.442,237.995,97.722,231.854,91.648,225.316z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M93.486,238.364c0,12.065-1.734,25.364-13.19,26.399c0.418-14.234,1.162-24.792,1.616-27.97 c1.28-8.915,6.037-12.564,10.431-14.044C92.896,225.392,93.486,229.668,93.486,238.364z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M112.432,245.2c-1.888,1.044-4.149,1.543-6.436,1.543c-3.087,0-6.228-0.908-8.561-2.605 c0.127-1.362,0.191-2.723,0.191-4.094c0-6.028-1.089-12.11-1.87-18.065c0.717-0.1,1.398-0.145,1.997-0.172 c1.807-0.073,3.005,0,3.005,0h6.709c0,0,1.507-0.1,3.677,0.036c0.853,0.045,1.707,0.2,2.551,0.445 C113.785,223.93,113.83,244.511,112.432,245.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M125.387,255.34c-0.363,0.045-0.735,0.064-1.117,0.064c-4.24,0-6.919-3.041-6.919-11.647 c0-4.793-0.86-18.438-1.187-20.426c2.914,1.598,5.429,4.457,6.781,8.388C123.943,234.651,124.76,243.848,125.387,255.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M111.474,223.985c0,3.875-3.143,7.032-7.032,7.032c-3.875,0-7.032-3.157-7.032-7.032 c0-0.761,0.115-1.493,0.344-2.181c1.808-0.072,2.999,0,2.999,0h6.717c0,0,1.507-0.1,3.674,0.043 C111.359,222.521,111.474,223.238,111.474,223.985z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.495,
    y: 207.71,
    style: {
      fill: "#FFBCB1"
    },
    width: 7.893,
    height: 19.92
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F91"
    },
    d: "M108.389,210.293v11.754c-6.028,0-7.893-5.08-7.893-5.08l1.478-4.248l5.497-2.827 L108.389,210.293z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M106.971,220.02L106.971,220.02c-6.182-0.65-10.707-6.24-10.057-12.421l1.434-13.639 c0.65-6.182,6.24-10.707,12.421-10.057h0c6.182,0.65,10.707,6.24,10.057,12.421l-1.434,13.639 C118.742,216.144,113.153,220.67,106.971,220.02z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M96.555,195.272c0.053,0,0.107,0.007,0.162,0.024c1.529,0.465,2.285,2.207,2.472,3.666 l-0.013,4.159c-0.393,0.157-0.805,0.233-1.214,0.233c-2.407,0-3.502-2.149-3.502-4.537 C94.46,196.637,95.784,195.272,96.555,195.272z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1046 -0.9945 0.9945 0.1046 -102.7646 286.6032)",
    style: {
      fill: "#1B1447"
    },
    cx: 107.78,
    cy: 200.371,
    rx: 1.199,
    ry: 1.006
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1046 -0.9945 0.9945 0.1046 -95.23 297.5882)",
    style: {
      fill: "#1B1447"
    },
    cx: 117.647,
    cy: 201.679,
    rx: 1.199,
    ry: 1.006
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M106.482,198.738c-0.077,0-0.152-0.039-0.194-0.109c-0.065-0.107-0.031-0.246,0.077-0.312 c0.659-0.399,1.42-0.576,2.136-0.501c0.382,0.04,0.745,0.15,1.081,0.326c0.111,0.059,0.153,0.195,0.095,0.307 c-0.059,0.111-0.195,0.153-0.307,0.095c-0.284-0.149-0.592-0.242-0.916-0.277c-0.622-0.064-1.281,0.091-1.854,0.438 C106.563,198.728,106.522,198.738,106.482,198.738z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M119.326,200.089c-0.056,0-0.112-0.02-0.156-0.062c-0.488-0.46-1.1-0.749-1.722-0.814 c-0.325-0.033-0.646-0.007-0.954,0.08c-0.12,0.035-0.246-0.036-0.28-0.157c-0.034-0.121,0.036-0.246,0.157-0.28 c0.363-0.103,0.743-0.134,1.124-0.094c0.72,0.075,1.425,0.407,1.986,0.934c0.091,0.086,0.096,0.23,0.01,0.321 C119.447,200.065,119.386,200.089,119.326,200.089z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M109.796,214.033c-0.769,0-1.555-0.098-2.331-0.295c-0.121-0.031-0.195-0.154-0.164-0.276 c0.031-0.121,0.152-0.198,0.276-0.164c2.016,0.513,4.1,0.318,5.717-0.536c0.11-0.059,0.248-0.016,0.307,0.095 c0.059,0.111,0.016,0.248-0.095,0.307C112.418,213.738,111.133,214.033,109.796,214.033z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M112.08,211.39c-0.053,0-0.104-0.001-0.153-0.004c-0.125-0.006-0.221-0.113-0.215-0.238 c0.007-0.125,0.121-0.223,0.238-0.215c1.381,0.068,4.211-0.904,4.552-1.966c-0.059-0.133-0.313-0.509-0.56-0.874 c-1.177-1.74-3.625-5.36-2.948-8.02c0.031-0.121,0.152-0.198,0.276-0.164c0.121,0.031,0.195,0.154,0.164,0.276 c-0.627,2.463,1.745,5.969,2.885,7.654c0.564,0.834,0.682,1.017,0.637,1.195C116.615,210.373,113.584,211.39,112.08,211.39z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M101.146,183.87c1.478-3.63,5.327-5.293,9.195-5.293c8.021,0,12.601,6.988,12.601,13.248 c0,0.85-0.434,3.141-1.1,4.626c-0.946,0.197-1.898,0.291-2.845,0.291c-5.449,0-10.751-3.104-14.096-7.428 c0.123,2.079,0.873,4.132,2.146,5.785c-1.829-1.008-3.266-2.671-4.309-4.504c-0.56,2.899-2.396,5.729-5.28,6.478 c-0.577-1.989-1.163-4.365-1.163-6.583c0-4.642,3.053-6.632,4.603-6.632C100.98,183.856,101.063,183.861,101.146,183.87z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M116.653,269.118c0.055,0.512,0.09,1.025,0.105,1.54c0.285,9.556-6.507,15.631-11.903,15.792 c-6.494,0.194-11.51-7.492-11.726-14.746c-0.023-0.774,0.009-1.544,0.099-2.298c4.87,0.038,11.386,0.36,17.146,0.188 C112.632,269.527,114.773,269.384,116.653,269.118z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 488.999,
    y: 345.293,
    style: {
      fill: "#4B5DB3"
    },
    width: 3.623,
    height: 17.918
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 488.999,
    y: 354.252,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 854.0219 -127.599)",
    style: {
      fill: "#4B5DB3"
    },
    width: 3.623,
    height: 17.918
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258.553,
    y: 345.293,
    style: {
      fill: "#4B5DB3"
    },
    width: 3.623,
    height: 17.918
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258.553,
    y: 354.252,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 623.576 102.8468)",
    style: {
      fill: "#4B5DB3"
    },
    width: 3.623,
    height: 17.918
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M267.69,350.249h-14.65c-3.219,0-5.853-2.634-5.853-5.853V233.677 c0-3.219,2.634-5.853,5.853-5.853h14.65c3.219,0,5.853,2.634,5.853,5.853v110.719 C273.542,347.615,270.908,350.249,267.69,350.249z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4B5DB3"
    },
    cx: 260.365,
    cy: 247.322,
    r: 7.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4B5DB3"
    },
    cx: 260.365,
    cy: 273.379,
    r: 7.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4B5DB3"
    },
    cx: 260.365,
    cy: 299.437,
    r: 7.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M498.135,350.249h-14.65c-3.219,0-5.853-2.634-5.853-5.853V233.677 c0-3.219,2.634-5.853,5.853-5.853h14.65c3.219,0,5.853,2.634,5.853,5.853v110.719 C503.988,347.615,501.354,350.249,498.135,350.249z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4B5DB3"
    },
    cx: 490.81,
    cy: 247.322,
    r: 7.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4B5DB3"
    },
    cx: 490.81,
    cy: 273.379,
    r: 7.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4B5DB3"
    },
    cx: 490.81,
    cy: 299.437,
    r: 7.76
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M564.264,439.68H186.911v-69.014c0-3.08,2.497-5.577,5.577-5.577h366.2 c3.08,0,5.577,2.497,5.577,5.577V439.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 345.554,
    y: 220.969,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 777.9717 26.7967)",
    style: {
      fill: "#3497C2"
    },
    width: 60.067,
    height: 362.829
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M256.545,385.927h-24.083c-0.935,0-1.699-0.765-1.699-1.699l0,0 c0-0.935,0.765-1.699,1.699-1.699h24.083c0.935,0,1.699,0.765,1.699,1.699l0,0 C258.245,385.163,257.48,385.927,256.545,385.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M256.545,420.212h-24.083c-0.935,0-1.699-0.765-1.699-1.699l0,0 c0-0.935,0.765-1.699,1.699-1.699h24.083c0.935,0,1.699,0.765,1.699,1.699l0,0 C258.245,419.448,257.48,420.212,256.545,420.212z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M343.934,385.927h-24.083c-0.935,0-1.699-0.765-1.699-1.699l0,0 c0-0.935,0.765-1.699,1.699-1.699h24.083c0.935,0,1.699,0.765,1.699,1.699l0,0 C345.634,385.163,344.869,385.927,343.934,385.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M343.934,420.212h-24.083c-0.935,0-1.699-0.765-1.699-1.699l0,0 c0-0.935,0.765-1.699,1.699-1.699h24.083c0.935,0,1.699,0.765,1.699,1.699l0,0 C345.634,419.448,344.869,420.212,343.934,420.212z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M431.323,385.927h-24.083c-0.935,0-1.699-0.765-1.699-1.699l0,0 c0-0.935,0.765-1.699,1.699-1.699h24.083c0.935,0,1.699,0.765,1.699,1.699l0,0 C433.023,385.163,432.258,385.927,431.323,385.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M431.323,420.212h-24.083c-0.935,0-1.699-0.765-1.699-1.699l0,0 c0-0.935,0.765-1.699,1.699-1.699h24.083c0.935,0,1.699,0.765,1.699,1.699l0,0 C433.023,419.448,432.258,420.212,431.323,420.212z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M518.712,385.927H494.63c-0.935,0-1.699-0.765-1.699-1.699l0,0 c0-0.935,0.765-1.699,1.699-1.699h24.083c0.935,0,1.699,0.765,1.699,1.699l0,0 C520.412,385.163,519.647,385.927,518.712,385.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M518.712,420.212H494.63c-0.935,0-1.699-0.765-1.699-1.699l0,0 c0-0.935,0.765-1.699,1.699-1.699h24.083c0.935,0,1.699,0.765,1.699,1.699l0,0 C520.412,419.448,519.647,420.212,518.712,420.212z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M173.557,411.037h-30.045v-11.339c0-2.716,2.209-4.926,4.925-4.926h20.195 c2.716,0,4.925,2.209,4.925,4.926V411.037z M146.236,408.314h24.598v-8.615c0-1.215-0.988-2.202-2.202-2.202h-20.195 c-1.214,0-2.201,0.988-2.201,2.202V408.314z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE4040"
    },
    d: "M188.599,402.905H128.47c-2.19,0-4.173,1.294-5.054,3.299l-4.497,10.233h79.231l-4.497-10.233 C192.772,404.2,190.789,402.905,188.599,402.905z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 118.919,
    y: 416.437,
    style: {
      fill: "#F65656"
    },
    width: 79.231,
    height: 23.048
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 118.919,
    y: 434.712,
    style: {
      fill: "#DE4040"
    },
    width: 79.231,
    height: 4.774
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M136.826,420.137h-1.602c-0.972,0-1.76-0.788-1.76-1.76v-3.879c0-0.972,0.788-1.76,1.76-1.76 h1.602c0.972,0,1.76,0.788,1.76,1.76v3.879C138.586,419.349,137.798,420.137,136.826,420.137z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M183.785,420.137h-1.602c-0.972,0-1.76-0.788-1.76-1.76v-3.879c0-0.972,0.788-1.76,1.76-1.76 h1.602c0.972,0,1.76,0.788,1.76,1.76v3.879C185.545,419.349,184.757,420.137,183.785,420.137z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 296.371,
    y: 305.356,
    transform: "matrix(0.9913 -0.1313 0.1313 0.9913 -38.8385 41.8758)",
    style: {
      fill: "#E6E6FE"
    },
    width: 3.643,
    height: 20.312
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M297.775,299.969l0.467,3.529c0.117,0.887-0.512,1.71-1.4,1.827 c-0.887,0.117-1.709-0.512-1.827-1.4l-0.467-3.529c-1.344,0.812-2.154,2.366-1.935,4.022c0.295,2.23,2.343,3.799,4.573,3.504 s3.799-2.343,3.504-4.573C300.471,301.692,299.285,300.403,297.775,299.969z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6FE"
    },
    d: "M298.776,332.319l-0.467-3.529c-0.117-0.887,0.512-1.71,1.4-1.827s1.709,0.512,1.827,1.4 l0.467,3.529c1.344-0.812,2.154-2.366,1.935-4.022c-0.295-2.23-2.343-3.799-4.573-3.504s-3.799,2.343-3.504,4.573 C296.08,330.596,297.267,331.885,298.776,332.319z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F91"
    },
    d: "M302.957,312.197c-0.542-0.883-1.324-1.782-2.36-1.817c-0.93-0.032-1.762,0.656-2.693,0.668 c-0.739,0.01-1.435-0.409-2.173-0.389c-2.15,0.058-5.489,5.681-7.64,5.686l2.911,4.398c2.536,0.829,5.235,1.503,7.852,0.986 c2.617-0.518,5.108-2.542,5.355-5.199C304.352,315.006,303.757,313.501,302.957,312.197z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M269.249,318.67c-2.075-11.963-2.438-23.033-13.119-31.918l-8.807,19.714 c1.496,8.565,5.647,16.772,11.02,23.68C262.265,326.783,265.814,322.679,269.249,318.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F91"
    },
    d: "M292.105,314.567c-5.923,2.388-16.454,3.698-22.775,4.57c-0.028-0.156-0.054-0.312-0.081-0.468 c-3.435,4.009-6.984,8.113-10.905,11.475c0.261,0.335,0.522,0.671,0.788,1c0.76,0.938,1.894,1.491,3.1,1.549 c10.482,0.496,24.302-6.564,32.815-11.651C294.572,317.522,294.355,316.844,292.105,314.567z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M186.911,429.974c-0.067-0.295-0.53-4.427-5.607-8.744l-14.756,17.355 c0,0,5.107,3.627,11.116-2.318C183.672,430.322,186.911,429.974,186.911,429.974z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M285.066,429.549c-0.138,0.242-2.438,3.272-1.234,9.936h22.78c0,0-1.672-6.24-10.225-6.967 S285.066,429.549,285.066,429.549z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M266.478,361.011c-6.473,4.076-36.439,5.102-46.38,0.69 c-0.635-16.386-0.527-20.623-0.145-33.687c0.418-14.234,1.162-24.792,1.616-27.97c1.28-8.915,6.037-12.564,10.431-14.044 c1.189-0.39,2.351-0.635,3.413-0.772c0.717-0.1,1.398-0.145,1.997-0.172c1.807-0.073,3.005,0,3.005,0h6.709 c0,0,1.507-0.1,3.677,0.036c0.853,0.045,1.707,0.2,2.551,0.445c0.844,0.245,1.67,0.599,2.469,1.044 c2.914,1.598,5.429,4.457,6.781,8.388c0.999,2.932,1.816,12.128,2.442,23.621C265.988,336.003,266.478,346.777,266.478,361.011 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M247.702,308.763c-1.826,4.851-4.414,9.782-8.079,13.373c3.955,2.608,9.314,4.81,15.21,6.54 c2.086-3.408,3.685-7.153,5.027-10.848C256.257,315.507,252.228,312.544,247.702,308.763z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M294.582,315.306c-0.368-0.845-0.947-1.735-1.855-1.895c-0.816-0.144-1.635,0.359-2.457,0.255 c-0.652-0.083-1.214-0.538-1.867-0.612c-4.957-0.562-8.247,9.427-32.458,3.719c-0.03,3.931-0.286,7.995-1.112,11.905 c10.608-0.588,22.262-3.046,30.658-6.228c1.388,0.507,2.825,0.832,4.292,0.751c2.372-0.132,4.819-1.607,5.366-3.919 C295.463,317.955,295.126,316.554,294.582,315.306z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M231.305,288.568c-6.997-4.038-17.392,11.41-8.598,19.704c6.065,6.413,7.24,7.521,17.17,15.654 c4.116-4.033,7.024-9.571,9.075-15.021C244.099,301.246,237.379,295.105,231.305,288.568z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M233.144,301.616c0,12.065-1.734,25.364-13.19,26.399c0.418-14.234,1.162-24.792,1.616-27.97 c1.28-8.915,6.037-12.564,10.431-14.044C232.554,288.643,233.144,292.919,233.144,301.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M252.09,308.451c-1.888,1.044-4.149,1.543-6.436,1.543c-3.087,0-6.228-0.908-8.561-2.605 c0.127-1.362,0.191-2.723,0.191-4.094c0-6.028-1.089-12.11-1.87-18.065c0.717-0.1,1.398-0.145,1.997-0.172 c1.807-0.073,3.005,0,3.005,0h6.709c0,0,1.507-0.1,3.677,0.036c0.853,0.045,1.707,0.2,2.551,0.445 C253.442,287.181,253.488,307.762,252.09,308.451z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M265.044,318.592c-0.363,0.045-0.735,0.064-1.117,0.064c-4.24,0-6.919-3.041-6.919-11.647 c0-4.793-0.86-18.438-1.187-20.426c2.914,1.598,5.429,4.457,6.781,8.388C263.6,297.903,264.418,307.099,265.044,318.592z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M251.131,287.236c0,3.875-3.143,7.032-7.032,7.032c-3.875,0-7.032-3.157-7.032-7.032 c0-0.761,0.115-1.493,0.344-2.181c1.808-0.072,2.999,0,2.999,0h6.717c0,0,1.507-0.1,3.674,0.043 C251.017,285.772,251.131,286.49,251.131,287.236z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.153,
    y: 270.961,
    style: {
      fill: "#FFBCB1"
    },
    width: 7.893,
    height: 19.92
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F91"
    },
    d: "M248.046,273.544v11.754c-6.028,0-7.893-5.08-7.893-5.08l1.478-4.248l5.497-2.827 L248.046,273.544z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M246.628,283.271L246.628,283.271c-6.182-0.65-10.707-6.24-10.057-12.421l1.434-13.639 c0.65-6.182,6.24-10.707,12.421-10.057h0c6.182,0.65,10.707,6.24,10.057,12.421l-1.434,13.639 C258.399,279.395,252.81,283.921,246.628,283.271z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M239.165,254.66c-1.291,2.087-2.359,5.719-2.359,8.701c0,0.732,0.064,1.424,0.206,2.046 c1.531-3.525,3.38-6.319,6.146-9.021L239.165,254.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M261.34,259.029l-0.009,0.127l-23.467-1.843c-0.227-0.109-0.463-0.218-0.69-0.327l0.073-0.763 c0.345-3.677,2.36-12.292,13.172-11.52c4.621,0.336,7.38,2.651,8.969,5.42c0.935,1.607,1.471,3.359,1.743,4.957 C261.413,256.642,261.431,258.058,261.34,259.029z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M268.125,260.599c-0.024,0-0.048-0.001-0.072-0.003l-30.951-2.433 c-0.5-0.039-0.873-0.477-0.834-0.977c0.039-0.5,0.475-0.87,0.977-0.834l30.951,2.433c0.5,0.039,0.873,0.477,0.834,0.977 C268.992,260.238,268.594,260.599,268.125,260.599z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M236.213,258.524c0.053,0,0.107,0.007,0.162,0.024c1.529,0.465,2.285,2.207,2.472,3.666 l-0.013,4.159c-0.393,0.157-0.805,0.233-1.214,0.233c-2.407,0-3.502-2.149-3.502-4.537 C234.117,259.888,235.441,258.524,236.213,258.524z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1046 -0.9945 0.9945 0.1046 -40.618 482.1304)",
    style: {
      fill: "#1B1447"
    },
    cx: 247.437,
    cy: 263.622,
    rx: 1.199,
    ry: 1.006
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1046 -0.9945 0.9945 0.1046 -33.0835 493.1153)",
    style: {
      fill: "#1B1447"
    },
    cx: 257.304,
    cy: 264.93,
    rx: 1.199,
    ry: 1.006
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M246.139,261.989c-0.077,0-0.152-0.039-0.194-0.109c-0.065-0.107-0.031-0.246,0.077-0.312 c0.659-0.399,1.42-0.576,2.136-0.501c0.382,0.04,0.745,0.15,1.081,0.326c0.111,0.059,0.153,0.195,0.095,0.307 c-0.059,0.111-0.195,0.153-0.307,0.095c-0.284-0.149-0.592-0.242-0.916-0.277c-0.622-0.064-1.281,0.091-1.854,0.438 C246.22,261.979,246.18,261.989,246.139,261.989z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M258.983,263.34c-0.056,0-0.112-0.02-0.156-0.062c-0.488-0.46-1.1-0.749-1.722-0.814 c-0.325-0.033-0.646-0.007-0.954,0.08c-0.12,0.035-0.246-0.036-0.28-0.157c-0.034-0.121,0.036-0.246,0.157-0.28 c0.363-0.103,0.743-0.134,1.124-0.094c0.72,0.075,1.425,0.407,1.986,0.934c0.091,0.086,0.096,0.23,0.01,0.321 C259.104,263.316,259.044,263.34,258.983,263.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M253.294,274.007l-0.232-0.443c0.981-0.514,1.458-1.053,1.458-1.647 c0-0.681-0.604-1.433-1.189-2.16c-0.634-0.788-1.29-1.604-1.29-2.448c0-0.144,0.019-0.285,0.057-0.423l0.482,0.133 c-0.026,0.095-0.039,0.19-0.039,0.29c0,0.668,0.6,1.414,1.179,2.135c0.639,0.795,1.299,1.617,1.299,2.474 C255.02,272.715,254.456,273.398,253.294,274.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M253.053,277.28c-1.746,0-3.746-0.602-4.976-1.496l0.294-0.404 c1.263,0.919,3.427,1.496,5.148,1.385l0.034,0.498C253.391,277.274,253.224,277.28,253.053,277.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M256.31,332.369c0.055,0.512,0.09,1.025,0.105,1.54c0.285,9.556-6.507,15.631-11.903,15.792 c-6.494,0.194-11.51-7.492-11.726-14.746c-0.023-0.774,0.009-1.544,0.099-2.298c4.87,0.038,11.386,0.36,17.146,0.188 C252.289,332.778,254.43,332.635,256.31,332.369z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M300.726,382.603c-0.002,0.001-34.253-24.303-34.253-24.303l-22.854-0.774h-23.522v17.317 c0.116,1.972-0.009,24.772-0.455,44.726c-11.668,1.322-22.211,2.489-35.627,2.689c-2.861,4.546-2.528,10.16,0.34,14.972 c14.962,2.617,27.796,2.627,48.976,1.997c2.421,0.091,4.843,0.031,7.256-0.227c1.409-14.205,6.851-50.954,7.459-62.963 c7.19,2.957,11.814,9.213,31.251,18.735c2.166,12.317,2.53,28.189,2.761,39.46c5.895,0.783,11.789-0.152,17.684-1.534 C301.334,416.655,301.357,399.702,300.726,382.603z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M261.131,255.08h-13.808v-4.957h12.065C260.323,251.73,260.859,253.482,261.131,255.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M464.472,345.496H288.478c-1.772,0-3.209-1.437-3.209-3.209V233.799 c0-1.772,1.437-3.209,3.209-3.209h175.994c1.772,0,3.209,1.437,3.209,3.209v108.488 C467.68,344.059,466.244,345.496,464.472,345.496z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M291.804,336.329v-96.571c0-1.454,1.179-2.633,2.633-2.633h164.076 c1.454,0,2.633,1.179,2.633,2.633v96.571c0,1.454-1.179,2.633-2.633,2.633H294.437 C292.983,338.961,291.804,337.783,291.804,336.329z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 329.188,
    y: 207.004,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 664.5181 -88.4315)",
    style: {
      fill: "#DEDCFA"
    },
    width: 94.574,
    height: 162.079
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1B1447"
    },
    points: "314.305,345.496 296.502,365.291 292.776,365.291 304.576,345.496  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1B1447"
    },
    points: "438.423,345.496 456.227,365.291 459.953,365.291 448.153,345.496  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEDCFA"
    },
    d: "M379.974,343.915h-7.219c-0.412,0-0.745-0.334-0.745-0.745v-1.95 c0-0.412,0.334-0.745,0.745-0.745h7.219c0.412,0,0.745,0.334,0.745,0.745v1.95C380.719,343.581,380.386,343.915,379.974,343.915 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M310.05,243.754h-9.336c-0.936,0-1.702,0.766-1.702,1.702v9.336c0,0.936,0.766,1.702,1.702,1.702 c0.936,0,1.702-0.766,1.702-1.702v-7.634h7.634c0.936,0,1.702-0.766,1.702-1.702C311.752,244.52,310.986,243.754,310.05,243.754 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M524.804,336.64h-30.045v-11.339c0-2.716,2.209-4.926,4.925-4.926h20.195 c2.716,0,4.925,2.209,4.925,4.926V336.64z M497.483,333.917h24.598v-8.615c0-1.215-0.988-2.202-2.202-2.202h-20.195 c-1.214,0-2.201,0.988-2.201,2.202V333.917z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE4040"
    },
    d: "M539.846,328.508h-60.129c-2.19,0-4.173,1.294-5.054,3.299l-4.497,10.233h79.231l-4.497-10.233 C544.019,329.803,542.036,328.508,539.846,328.508z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 470.166,
    y: 342.041,
    style: {
      fill: "#F65656"
    },
    width: 79.231,
    height: 23.048
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 470.166,
    y: 360.315,
    style: {
      fill: "#DE4040"
    },
    width: 79.231,
    height: 4.774
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M488.073,345.74h-1.602c-0.972,0-1.76-0.788-1.76-1.76v-3.879c0-0.972,0.788-1.76,1.76-1.76 h1.602c0.972,0,1.76,0.788,1.76,1.76v3.879C489.833,344.952,489.045,345.74,488.073,345.74z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M535.031,345.74h-1.602c-0.972,0-1.76-0.788-1.76-1.76v-3.879c0-0.972,0.788-1.76,1.76-1.76 h1.602c0.972,0,1.76,0.788,1.76,1.76v3.879C536.792,344.952,536.003,345.74,535.031,345.74z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 505.964,
    y: 92.214,
    style: {
      fill: "#E6E6FE"
    },
    width: 6.355,
    height: 347.466
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 570.567,
    y: 92.214,
    style: {
      fill: "#E6E6FE"
    },
    width: 6.355,
    height: 347.466
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 503.695,
    y: 429.169,
    style: {
      fill: "#E6E6FE"
    },
    width: 10.894,
    height: 10.511
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 568.297,
    y: 429.169,
    style: {
      fill: "#E6E6FE"
    },
    width: 10.894,
    height: 10.511
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.141,
    y: 106.859,
    style: {
      fill: "#E6E6FE"
    },
    width: 64.603,
    height: 3.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.141,
    y: 135.947,
    style: {
      fill: "#E6E6FE"
    },
    width: 64.603,
    height: 3.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.141,
    y: 165.035,
    style: {
      fill: "#E6E6FE"
    },
    width: 64.603,
    height: 3.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.141,
    y: 194.123,
    style: {
      fill: "#E6E6FE"
    },
    width: 64.603,
    height: 3.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.141,
    y: 223.211,
    style: {
      fill: "#E6E6FE"
    },
    width: 64.603,
    height: 3.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.141,
    y: 252.299,
    style: {
      fill: "#E6E6FE"
    },
    width: 64.603,
    height: 3.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.141,
    y: 281.387,
    style: {
      fill: "#E6E6FE"
    },
    width: 64.603,
    height: 3.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.141,
    y: 310.475,
    style: {
      fill: "#E6E6FE"
    },
    width: 64.603,
    height: 3.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.141,
    y: 339.563,
    style: {
      fill: "#E6E6FE"
    },
    width: 64.603,
    height: 3.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.141,
    y: 368.651,
    style: {
      fill: "#E6E6FE"
    },
    width: 64.603,
    height: 3.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.141,
    y: 397.739,
    style: {
      fill: "#E6E6FE"
    },
    width: 64.603,
    height: 3.631
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M468.282,117.896l-1.628,0.932c-0.491,0.281-1.117,0.111-1.398-0.38l-6.841-11.944 c-0.281-0.491-0.111-1.117,0.38-1.398l1.628-0.932c0.491-0.281,1.117-0.111,1.398,0.38l6.841,11.944 C468.943,116.989,468.773,117.615,468.282,117.896z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M451.684,89.901l-0.778,0.446c-0.143,0.082-0.192,0.263-0.11,0.406l1.29,2.253 c0.082,0.143,0.263,0.192,0.406,0.11l0.065-0.037l9.233,16.121c0.102,0.179,0.33,0.241,0.509,0.138 c0.179-0.102,0.241-0.33,0.138-0.509l-9.233-16.121l0.065-0.037c0.143-0.082,0.192-0.263,0.11-0.406l-1.29-2.253 C452.008,89.869,451.826,89.819,451.684,89.901z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M470.61,107.377c-0.92-0.746-5.032-2.736-5.937-2.667c-0.466,0.036-0.917,0.275-1.343,0.816 c-3.718,0.598-5.273,2.964-5.093,5.318c0.253,3.301,3.658,5.594,6.851,5.35c1.945-0.149,4.09-1.389,5.543-2.502L470.61,107.377z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M528.415,94.163l-26.6,12.696l-31.988-1.77c0,0-2.275,5.397-2.137,11.171l38.275,4.918 l26.182-5.146L528.415,94.163z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M568.331,300.381c0.182,0.242,3.029,3.272,3.029,9.936h-22.78c0,0,0.545-6.24,8.967-6.967 S568.331,300.381,568.331,300.381z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M528.891,300.381c0.138,0.242,2.438,3.272,1.234,9.936h-22.78c0,0,1.672-6.24,10.225-6.967 S528.891,300.381,528.891,300.381z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M518.002,177.028h46.136v17.317c-0.311,5.289,1.111,67.906,5.794,108.031 c-4.133,3.431-9.07,2.192-14.888,1.621c-7.856-25.015-12.727-67.175-14.428-100.783c-3.505,22.917-8.722,71.6-10.484,99.162 c-4.752,3.431-9.466,2.192-15.18,1.621C510.979,274.219,518.002,177.028,518.002,177.028z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M517.757,180.513c6.473,4.076,36.439,5.102,46.38,0.69c0.635-16.386,0.527-32.545,0.145-45.608 c-0.418-14.234-1.162-24.792-1.616-27.97c-1.28-8.915-6.037-12.564-10.431-14.044c-1.189-0.39-2.351-0.635-3.413-0.772 c-0.717-0.1-1.398-0.145-1.997-0.172c-1.807-0.073-3.005,0-3.005,0h-6.709c0,0-1.507-0.1-3.677,0.036 c-0.853,0.045-1.707,0.2-2.551,0.445s-1.67,0.599-2.469,1.044c-2.914,1.598-5.429,4.457-6.781,8.388 c-0.999,2.932-1.816,12.128-2.442,23.621C518.247,143.584,517.757,166.279,517.757,180.513z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M533.104,94.816c0,3.875,3.143,7.032,7.032,7.032c3.875,0,7.032-3.157,7.032-7.032 c0-0.761-0.115-1.493-0.344-2.181c-1.808-0.072-2.999,0-2.999,0h-6.717c0,0-1.507-0.1-3.674,0.043 C533.219,93.352,533.104,94.07,533.104,94.816z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 536.19,
    y: 78.542,
    style: {
      fill: "#FFBCB1"
    },
    width: 7.893,
    height: 19.92
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F91"
    },
    d: "M536.19,81.125v11.754c6.028,0,7.893-5.08,7.893-5.08l-1.478-4.248l-5.497-2.827L536.19,81.125 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M537.607,90.851L537.607,90.851c6.182-0.65,10.707-6.24,10.057-12.421l-1.434-13.639 c-0.65-6.182-6.24-10.707-12.421-10.057l0,0c-6.182,0.65-10.707,6.24-10.057,12.421l1.434,13.639 C525.836,86.976,531.426,91.501,537.607,90.851z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M548.023,66.104c-0.053,0-0.107,0.007-0.162,0.024c-1.529,0.465-2.285,2.207-2.472,3.666 l0.013,4.159c0.393,0.157,0.805,0.233,1.214,0.233c2.407,0,3.502-2.149,3.502-4.537 C550.119,67.468,548.795,66.104,548.023,66.104z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9945 -0.1046 0.1046 0.9945 -4.5029 56.5326)",
    style: {
      fill: "#1B1447"
    },
    cx: 536.799,
    cy: 71.202,
    rx: 1.006,
    ry: 1.199
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9945 -0.1046 0.1046 0.9945 -4.6938 55.5078)",
    style: {
      fill: "#1B1447"
    },
    cx: 526.931,
    cy: 72.511,
    rx: 1.006,
    ry: 1.199
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M538.096,69.57c0.077,0,0.152-0.039,0.194-0.109c0.065-0.107,0.031-0.246-0.077-0.312 c-0.659-0.399-1.42-0.576-2.136-0.501c-0.382,0.04-0.745,0.15-1.081,0.326c-0.111,0.059-0.153,0.195-0.095,0.307 c0.059,0.111,0.195,0.153,0.307,0.095c0.284-0.149,0.592-0.242,0.916-0.277c0.622-0.064,1.281,0.091,1.854,0.438 C538.016,69.559,538.056,69.57,538.096,69.57z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M525.252,70.92c0.056,0,0.112-0.02,0.156-0.062c0.488-0.46,1.1-0.749,1.722-0.814 c0.325-0.033,0.646-0.007,0.954,0.08c0.12,0.035,0.246-0.036,0.28-0.157c0.034-0.121-0.036-0.246-0.157-0.28 c-0.363-0.103-0.743-0.134-1.124-0.094c-0.72,0.075-1.425,0.407-1.986,0.934c-0.091,0.086-0.096,0.23-0.01,0.321 C525.132,70.896,525.192,70.92,525.252,70.92z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M533.927,84.29c-1.01,0-1.887-0.156-2.444-0.288l0.104-0.441 c0.535,0.126,1.374,0.276,2.34,0.276c1.346,0,3.15-0.294,4.103-1.697l0.376,0.255 C537.341,83.961,535.382,84.29,533.927,84.29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M534.145,81.071c-2.481-0.274-3.586-0.904-3.586-2.042c0-0.584,0.256-1.156,0.527-1.761 c0.335-0.748,0.714-1.595,0.714-2.666c0-0.758-0.153-1.483-0.316-2.251c-0.066-0.312-0.132-0.625-0.188-0.941l0.447-0.079 c0.055,0.312,0.12,0.619,0.185,0.926c0.16,0.757,0.325,1.54,0.325,2.345c0,1.168-0.4,2.063-0.753,2.852 c-0.262,0.584-0.487,1.089-0.487,1.576c0,0.577,0.362,1.279,3.182,1.59L534.145,81.071z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M546.519,67.491c0.365-1.36,0.558-2.803,0.558-4.251c0-7.548-5.323-11.932-12.202-11.932 c-7.176,0-12.05,4.314-12.05,11.355c0,2.236,0.676,4.61,1.16,6.721c0.321-0.921,0.514-2.498,0.889-3.397 c-0.091-0.423-0.144-0.893-0.144-1.372c0-0.859,0.171-1.744,0.605-2.427c1.496,0.937,3.266,1.352,5.102,1.352 c3.84,0,7.964-1.811,10.449-4.434c0.937,0.982,1.737,2.107,1.737,3.284c0,0.615-0.219,1.244-0.751,1.875 C543.609,64.915,545.599,65.886,546.519,67.491z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5DB3"
    },
    d: "M564.138,181.203c-9.94,8.305-39.907,7.148-46.38-0.69c0-14.234,0.49-36.93,1.434-54.341 c0.363,0.045,0.735,0.064,1.117,0.064c4.239,0,6.917-3.041,6.917-11.647c0-4.793,0.862-18.438,1.189-20.426 c0.799-0.445,1.625-0.799,2.469-1.044c-0.091,1.643-0.136,22.223,1.262,22.913c1.888,1.044,4.149,1.543,6.436,1.543 c3.086,0,6.228-0.908,8.561-2.605c-0.127-1.362-0.191-2.723-0.191-4.094c0-6.028,1.089-12.11,1.87-18.065 c1.062,0.136,2.224,0.381,3.413,0.772c-0.554,2.642-1.144,6.917-1.144,15.614c0,12.065,1.558,20.094,13.014,21.129 C564.489,143.388,564.774,164.817,564.138,181.203z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M527.925,139.95c-0.055,0.512-0.09,1.025-0.105,1.54c-0.285,9.556,6.506,15.631,11.903,15.792 c6.494,0.194,11.51-7.492,11.726-14.746c0.023-0.774-0.009-1.544-0.099-2.298c-4.87,0.038-11.386,0.36-17.146,0.188 C531.947,140.359,529.806,140.215,527.925,139.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 546.43,
    y: 161.266,
    transform: "matrix(0.4448 -0.8956 0.8956 0.4448 150.8541 586.1992)",
    style: {
      fill: "#1B1447"
    },
    width: 3.643,
    height: 20.312
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M535.127,163.086l3.188,1.583c0.802,0.398,1.132,1.38,0.734,2.181 c-0.398,0.802-1.38,1.132-2.181,0.734l-3.188-1.583c-0.077,1.569,0.759,3.108,2.256,3.852c2.015,1.001,4.46,0.179,5.46-1.836 s0.179-4.46-1.836-5.46C538.062,161.813,536.33,162.076,535.127,163.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M562.52,180.325l-3.188-1.583c-0.802-0.398-1.132-1.38-0.734-2.181s1.38-1.132,2.181-0.734 l3.188,1.583c0.077-1.569-0.759-3.108-2.256-3.852c-2.015-1.001-4.46-0.179-5.46,1.836c-1.001,2.015-0.179,4.46,1.836,5.46 C559.584,181.598,561.317,181.334,562.52,180.325z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBCB1"
    },
    d: "M547.239,164.075c2.207,0.927,4.314,2.044,6.594,2.784c0.121,0.927,0.23,1.981,0.23,3.036 c0,4.545-2.516,6.628-5.407,6.628c-2.587,0-4.947-1.977-4.947-4.696c0-0.523,0.088-1.075,0.278-1.644 c-0.282-0.442-0.404-0.893-0.404-1.341C543.583,166.988,545.677,165.166,547.239,164.075z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M568.757,119.793c-3.895-22.837-16.52-26.211-16.52-26.211l4.127,22.679l2.189,20.557 l-13.345,27.79c6.537,6.94,9.823,6.053,9.823,6.053s8.934-16.202,16.318-31.645 C570.668,132.646,569.817,126.011,568.757,119.793z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#857DE2"
    },
    d: "M616.867,352.276c3.446-0.925,6.724-1.996,9.649-3.848c-1.062-0.974-1.893-2.141-2.156-3.832 c-0.485-3.12,0.985-6.406,0.508-9.471c-0.79-5.083-6.832-4.612-7.515-9.008c-0.527-3.39,1.674-6.333,1.138-9.781 c-0.986-6.342-9.62-8.06-10.326-12.6c-0.604-3.886,2.327-7.699,1.618-12.258c-1.147-7.376-7.301-5.777-8.234-11.777 c-0.311-2.002-0.273-4.469-0.615-6.671c-0.638-4.101-2.718-6.283-7.127-5.597c-2.317,0.36-4.474,2.845-4.055,5.536 c0.558,3.59,5.005,6.953,5.53,10.334c0.006,0.04,0.012,0.081,0.017,0.121c0.294,2.307-2.026,4.315-1.626,6.885 c0.619,3.979,8.146,5.374,9.088,11.435c0.508,3.269-2.793,6.048-2.268,9.425c0.571,3.672,4.998,4.662,5.588,8.454 c0.474,3.046-1.566,6.211-1.109,9.152c0.765,4.923,7.659,4.546,8.504,9.981c0.421,2.706-0.865,5.347-0.439,8.083 C613.379,349.032,615.076,351.064,616.867,352.276z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M623.82,354.019c-0.094,0-0.189-0.035-0.262-0.106c-3.689-3.601-4.548-6.353-4.927-8.79 c-0.141-0.906-0.212-1.797-0.287-2.74c-0.079-0.988-0.16-2.011-0.33-3.098c-0.759-4.881-2.426-6.093-4.038-7.265 c-1.373-0.998-2.668-1.939-3.129-4.9c-0.32-2.059-0.041-4.111,0.229-6.096c0.261-1.919,0.532-3.903,0.232-5.83 c-0.337-2.115-1.53-3.514-2.793-4.995c-1.42-1.666-2.89-3.39-3.328-6.212c-0.265-1.704-0.167-3.437-0.072-5.112 c0.093-1.641,0.189-3.337-0.065-4.972c-0.476-3.063-1.995-4.353-3.464-5.6c-1.116-0.948-2.27-1.928-2.916-3.628 c-0.521-1.373-0.77-2.69-1.009-3.965c-0.467-2.484-0.871-4.63-3.114-6.607c-0.155-0.137-0.17-0.374-0.033-0.529 s0.375-0.169,0.529-0.033c2.436,2.148,2.882,4.521,3.355,7.031c0.233,1.242,0.475,2.526,0.973,3.838 c0.577,1.519,1.608,2.395,2.7,3.321c1.574,1.336,3.2,2.718,3.72,6.057c0.266,1.713,0.168,3.45,0.073,5.13 c-0.092,1.636-0.188,3.328,0.065,4.954c0.406,2.613,1.805,4.254,3.158,5.84c1.275,1.495,2.593,3.041,2.957,5.326 c0.323,2.075,0.045,4.115-0.223,6.088c-0.263,1.931-0.535,3.928-0.231,5.879c0.413,2.652,1.532,3.467,2.829,4.408 c1.655,1.204,3.532,2.567,4.338,7.757c0.173,1.114,0.256,2.15,0.336,3.153c0.074,0.929,0.144,1.807,0.28,2.685 c0.359,2.31,1.178,4.922,4.709,8.368c0.148,0.145,0.151,0.382,0.007,0.53C624.015,353.98,623.917,354.019,623.82,354.019z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M619.856,345.41c3.547-0.384,6.95-0.94,10.125-2.32c-0.9-1.125-1.542-2.406-1.542-4.118 c0-3.158,1.957-6.179,1.957-9.28c0-5.144-6.042-5.607-6.042-10.056c0-3.431,2.627-6,2.627-9.49 c0-6.418-8.267-9.442-8.267-14.037c0-3.933,3.482-7.251,3.482-11.864c0-7.465-6.327-6.83-6.327-12.902 c0-2.026,0.417-4.458,0.417-6.687c0-4.15-1.72-6.626-6.182-6.626c-2.345,0-4.858,2.124-4.858,4.847 c0,3.633,3.877,7.64,3.877,11.061c0,0.041-0.001,0.081-0.002,0.122c-0.064,2.325-2.665,3.952-2.665,6.553 c0,4.027,7.224,6.561,7.224,12.696c0,3.308-3.689,5.547-3.689,8.964c0,3.716,4.223,5.375,4.223,9.213 c0,3.083-2.502,5.897-2.502,8.873c0,4.982,6.87,5.668,6.87,11.169c0,2.739-1.676,5.151-1.676,7.919 C616.908,341.669,618.273,343.938,619.856,345.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M626.517,348.204c-0.114,0-0.227-0.052-0.3-0.15c-3.092-4.123-3.519-6.975-3.519-9.442 c0-0.917,0.067-1.809,0.138-2.754c0.074-0.987,0.151-2.009,0.151-3.108c0-4.939-1.461-6.394-2.875-7.8 c-1.203-1.196-2.338-2.326-2.338-5.322c0-2.084,0.591-4.068,1.163-5.987c0.553-1.856,1.125-3.776,1.125-5.727 c-0.008-2.141-0.972-3.707-1.993-5.365c-1.148-1.864-2.335-3.792-2.335-6.648c0-1.725,0.363-3.421,0.714-5.062 c0.344-1.607,0.7-3.269,0.7-4.924c0-3.1-1.303-4.607-2.563-6.066c-0.957-1.107-1.947-2.253-2.323-4.031 c-0.305-1.438-0.347-2.777-0.388-4.072c-0.08-2.527-0.149-4.709-2.062-7.008c-0.133-0.159-0.111-0.396,0.048-0.528 c0.158-0.133,0.395-0.111,0.528,0.048c2.077,2.497,2.154,4.91,2.235,7.464c0.04,1.263,0.082,2.568,0.372,3.94 c0.337,1.59,1.221,2.614,2.158,3.697c1.349,1.563,2.745,3.178,2.745,6.557c0,1.734-0.364,3.436-0.716,5.08 c-0.343,1.603-0.697,3.26-0.697,4.905c0,2.644,1.13,4.48,2.224,6.256c1.03,1.673,2.095,3.403,2.104,5.717 c0,2.101-0.588,4.073-1.156,5.981c-0.557,1.868-1.132,3.799-1.132,5.773c0,2.685,0.981,3.66,2.117,4.791 c1.451,1.443,3.096,3.079,3.096,8.331c0,1.127-0.078,2.163-0.153,3.165c-0.07,0.93-0.136,1.809-0.136,2.697 c0,2.338,0.408,5.045,3.368,8.993c0.125,0.165,0.091,0.4-0.075,0.524C626.674,348.18,626.595,348.204,626.517,348.204z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#857DE2"
    },
    d: "M619.532,345.846c3.56,0.231,7.008,0.269,10.373-0.545c-0.693-1.263-1.106-2.635-0.811-4.322 c0.543-3.111,2.99-5.751,3.523-8.806c0.884-5.068-4.988-6.562-4.224-10.945c0.59-3.38,3.619-5.459,4.219-8.898 c1.103-6.322-6.522-10.722-5.732-15.249c0.676-3.874,4.676-6.544,5.469-11.09c1.283-7.354-5.059-7.815-4.015-13.797 c0.348-1.996,1.177-4.32,1.56-6.516c0.713-4.089-0.556-6.823-4.951-7.59c-2.31-0.403-5.15,1.257-5.618,3.941 c-0.624,3.579,2.506,8.192,1.919,11.562c-0.007,0.04-0.015,0.08-0.023,0.12c-0.462,2.28-3.304,3.436-3.751,5.998 c-0.692,3.967,5.989,7.705,4.934,13.748c-0.569,3.259-4.587,4.831-5.175,8.197c-0.639,3.661,3.237,6.02,2.577,9.801 c-0.53,3.037-3.478,5.379-3.99,8.311c-0.856,4.908,5.794,6.765,4.849,12.183c-0.471,2.698-2.536,4.786-3.012,7.514 C617.27,341.654,618.225,344.123,619.532,345.846z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M625.678,349.749c-0.137,0-0.269-0.075-0.335-0.205c-2.337-4.594-2.267-7.477-1.843-9.907 c0.158-0.903,0.377-1.771,0.609-2.689c0.243-0.96,0.494-1.953,0.683-3.036c0.849-4.866-0.341-6.55-1.492-8.178 c-0.979-1.385-1.904-2.693-1.389-5.645c0.358-2.053,1.282-3.906,2.175-5.699c0.864-1.733,1.757-3.526,2.092-5.447 c0.36-2.11-0.32-3.818-1.041-5.627c-0.81-2.034-1.648-4.138-1.157-6.952c0.296-1.699,0.946-3.308,1.574-4.864 c0.615-1.523,1.25-3.1,1.535-4.729c0.533-3.054-0.491-4.763-1.481-6.416c-0.753-1.256-1.531-2.555-1.597-4.371 c-0.053-1.469,0.136-2.796,0.318-4.079c0.355-2.503,0.662-4.664-0.827-7.258c-0.103-0.18-0.041-0.408,0.139-0.512 c0.179-0.106,0.409-0.041,0.512,0.139c1.618,2.816,1.278,5.206,0.919,7.736c-0.178,1.251-0.361,2.545-0.311,3.946 c0.058,1.624,0.753,2.784,1.49,4.013c1.061,1.771,2.158,3.602,1.578,6.931c-0.298,1.709-0.949,3.321-1.579,4.882 c-0.613,1.52-1.247,3.091-1.53,4.712c-0.455,2.605,0.343,4.608,1.115,6.545c0.727,1.825,1.479,3.713,1.09,5.993 c-0.361,2.069-1.279,3.912-2.167,5.694c-0.87,1.744-1.768,3.548-2.107,5.493c-0.461,2.644,0.337,3.774,1.263,5.083 c1.181,1.671,2.521,3.565,1.618,8.739c-0.194,1.11-0.449,2.117-0.695,3.091c-0.229,0.904-0.444,1.759-0.597,2.635 c-0.402,2.303-0.465,5.04,1.773,9.438c0.094,0.185,0.02,0.41-0.165,0.504C625.793,349.736,625.735,349.749,625.678,349.749z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB800"
    },
    d: "M621.561,338.325c3.479,0.791,6.878,1.373,10.329,1.101c-0.485-1.357-0.675-2.777-0.118-4.396 c1.027-2.986,3.861-5.206,4.87-8.138c1.674-4.864-3.889-7.268-2.441-11.475c1.116-3.244,4.437-4.819,5.572-8.119 c2.088-6.069-4.745-11.618-3.25-15.963c1.28-3.719,5.651-5.723,7.153-10.086c2.429-7.059-3.76-8.517-1.785-14.258 c0.659-1.916,1.845-4.08,2.57-6.187c1.35-3.925,0.529-6.825-3.69-8.277c-2.217-0.763-5.284,0.427-6.17,3.003 c-1.182,3.435,1.18,8.485,0.067,11.72c-0.013,0.039-0.027,0.077-0.041,0.115c-0.817,2.178-3.806,2.87-4.652,5.33 c-1.31,3.808,4.696,8.555,2.7,14.355c-1.076,3.128-5.293,4.045-6.405,7.276c-1.209,3.514,2.244,6.456,0.996,10.085 c-1.003,2.915-4.285,4.762-5.253,7.576c-1.621,4.711,4.652,7.595,2.862,12.796c-0.891,2.59-3.261,4.326-4.161,6.943 C619.99,333.828,620.543,336.417,621.561,338.325z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M627.072,343.154c-0.159,0-0.306-0.101-0.357-0.26c-1.582-4.905-1.057-7.741-0.254-10.074 c0.298-0.867,0.652-1.688,1.026-2.559c0.392-0.91,0.796-1.852,1.154-2.892c1.607-4.671,0.698-6.521-0.18-8.31 c-0.748-1.522-1.455-2.961-0.479-5.794c0.678-1.97,1.883-3.654,3.048-5.283c1.127-1.575,2.292-3.204,2.927-5.048 c0.689-2.028,0.287-3.822-0.139-5.722c-0.479-2.137-0.974-4.346-0.044-7.047c0.561-1.631,1.457-3.116,2.322-4.554 c0.848-1.408,1.725-2.863,2.264-4.429c1.008-2.932,0.267-4.781-0.45-6.569c-0.544-1.359-1.108-2.765-0.885-4.569 c0.18-1.458,0.575-2.737,0.958-3.976c0.747-2.416,1.391-4.502,0.331-7.298c-0.073-0.193,0.024-0.41,0.218-0.483 c0.19-0.073,0.41,0.023,0.483,0.218c1.152,3.037,0.439,5.343-0.315,7.785c-0.373,1.206-0.758,2.454-0.93,3.846 c-0.199,1.613,0.305,2.869,0.837,4.198c0.768,1.916,1.562,3.897,0.462,7.093c-0.564,1.64-1.462,3.131-2.331,4.571 c-0.846,1.404-1.72,2.855-2.255,4.411c-0.86,2.5-0.389,4.604,0.067,6.639c0.429,1.917,0.874,3.899,0.129,6.09 c-0.683,1.986-1.881,3.661-3.039,5.28c-1.134,1.585-2.307,3.224-2.949,5.091c-0.873,2.538-0.263,3.78,0.443,5.219 c0.902,1.837,1.925,3.919,0.216,8.885c-0.367,1.066-0.777,2.021-1.174,2.944c-0.369,0.856-0.717,1.665-1.006,2.506 c-0.761,2.211-1.255,4.903,0.259,9.6c0.063,0.197-0.045,0.408-0.242,0.472C627.148,343.148,627.11,343.154,627.072,343.154z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#857DE2"
    },
    d: "M620.753,356.123c3.308,1.336,6.57,2.454,10.021,2.737c-0.262-1.417-0.223-2.849,0.585-4.358 c1.491-2.783,4.643-4.522,6.107-7.256c2.429-4.534-2.678-7.795-0.577-11.717c1.62-3.024,5.149-4.048,6.797-7.125 c3.03-5.657-2.829-12.227-0.659-16.277c1.857-3.467,6.493-4.747,8.672-8.814c3.525-6.58-2.352-9.008,0.515-14.36 c0.957-1.786,2.473-3.733,3.525-5.697c1.96-3.659,1.613-6.653-2.321-8.76c-2.067-1.107-5.285-0.422-6.571,1.979 c-1.715,3.202-0.19,8.565-1.805,11.581c-0.019,0.036-0.039,0.072-0.059,0.107c-1.154,2.019-4.215,2.226-5.443,4.518 c-1.901,3.549,3.269,9.195,0.372,14.602c-1.562,2.916-5.871,3.148-7.485,6.16c-1.755,3.276,1.185,6.732-0.628,10.115 c-1.456,2.718-4.99,4.017-6.396,6.64c-2.353,4.392,3.379,8.241,0.782,13.089c-1.293,2.414-3.91,3.749-5.217,6.19 C619.92,351.433,620.052,354.077,620.753,356.123z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B1447"
    },
    d: "M625.48,361.775c-0.182,0-0.342-0.133-0.37-0.318c-0.778-5.094,0.193-7.81,1.358-9.984 c0.434-0.81,0.914-1.565,1.423-2.365c0.531-0.835,1.081-1.699,1.6-2.667c2.333-4.354,1.731-6.326,1.149-8.232 c-0.495-1.623-0.962-3.155,0.452-5.796c0.984-1.837,2.443-3.308,3.853-4.729c1.364-1.375,2.774-2.797,3.695-4.516 c1.004-1.892,0.894-3.727,0.777-5.67c-0.131-2.186-0.267-4.445,1.082-6.963c0.814-1.521,1.936-2.845,3.02-4.126 c1.062-1.254,2.16-2.551,2.941-4.009c1.464-2.733,1.028-4.678,0.606-6.559c-0.321-1.428-0.652-2.905-0.144-4.65 c0.41-1.411,1.005-2.612,1.581-3.773c1.123-2.265,2.092-4.222,1.492-7.15c-0.042-0.203,0.089-0.401,0.292-0.442 c0.203-0.047,0.401,0.089,0.442,0.292c0.652,3.182-0.419,5.344-1.554,7.634c-0.561,1.132-1.141,2.303-1.533,3.649 c-0.454,1.561-0.158,2.88,0.156,4.277c0.452,2.015,0.919,4.098-0.677,7.076c-0.819,1.528-1.943,2.856-3.03,4.141 c-1.059,1.251-2.154,2.544-2.931,3.994c-1.249,2.331-1.119,4.482-0.994,6.563c0.118,1.962,0.24,3.99-0.845,6.033 c-0.992,1.852-2.441,3.313-3.843,4.727c-1.373,1.384-2.792,2.814-3.725,4.555c-1.268,2.366-0.864,3.69-0.396,5.224 c0.598,1.957,1.274,4.176-1.205,8.805c-0.532,0.993-1.089,1.869-1.628,2.716c-0.501,0.788-0.974,1.532-1.395,2.316 c-1.104,2.062-2.023,4.641-1.278,9.518c0.031,0.205-0.109,0.396-0.314,0.428C625.519,361.774,625.5,361.775,625.48,361.775z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3497C2"
    },
    d: "M644.751,346.56c0-11.318,0-15.739,0-15.739h-19.925h-19.925c0,0,0,4.421,0,15.739 c0,12.603-35.62,33.669-5.323,93.12h50.501C680.878,379.195,644.751,359.901,644.751,346.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 600.881,
    y: 327.322,
    style: {
      fill: "#4B5DB3"
    },
    width: 48.114,
    height: 3.499
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.68c6722700c7a7cd1922a392108501a9.svg";
export { ForwardRef as ReactComponent };